<nz-drawer
  [nzBodyStyle]="{ overflow: 'auto' }"
  [nzMaskClosable]="false"
  [nzWidth]="750"
  [nzVisible]="isVisibleEmailsDrawer"
  [nzTitle]="retailProgramsDefaultDrawerTitle"
  [nzFooter]="footerTpl"
  (nzOnClose)="cancelEmailsDrawer()"
>
  <ng-container *nzDrawerContent>
  <!-- Select All -->
  <label class="select-all-check-box-title" nz-checkbox
         [(ngModel)]="allChecked"
         (ngModelChange)="updateAllChecked()">
    Select all
  </label>

  <!-- <ng-container *ngFor="let group of emailDefault; let i = index">
    <div class="set-default-box">
      <label nz-checkbox [(ngModel)]="group.isChecked"
             (ngModelChange)="headerCheckUncheckAll(i, group.isChecked)">
        {{ group.title }}
      </label>


      <div class="event-row header-row justify-content-space-around">

        <span class="col-subject">Subject</span>
        <span class="col-trigger">Trigger</span>
        <span class="col-remark">Remark</span>
      </div>

      <ng-container *ngFor="let event of group.events; let j = index">
        <label nz-checkbox
               class="event-row checkbox-row"
               [(ngModel)]="event.isChecked"
               (ngModelChange)="subHeaderCheckUncheck(i, j, $event)">
               <span class="info-container">
          <span class="col-subject">{{ event.subject }}</span>
          <span class="col-trigger">{{ event.triggerOn }}</span>
          <span class="col-remark">{{ event.remark }}</span>
          </span>
        </label>
      </ng-container>
    </div>
  </ng-container> -->

<div *ngFor="let group of emailDefault; let i = index" class="mb-4">
  <!-- Group Header Row -->
    <label nz-checkbox [(ngModel)]="group.isChecked"
           (ngModelChange)="headerCheckUncheckAll(i, group.isChecked)">
      <span class="notifi-title">{{ group.title }}</span>
    </label>

  <!-- Table for events -->
  <nz-table [nzData]="group.events" nzSize="small" class="email-table" [nzShowPagination]="false">
    <!-- <thead>
      <tr>
        <th></th>
        <th class="col-subject">Subject</th>
        <th class="col-trigger">Trigger</th>
        <th class="col-remark">Remark</th>
      </tr>
    </thead> -->
    <tbody class="email-noti-table">
      <tr *ngFor="let event of group.events; let j = index" (click)="event.isChecked = !event.isChecked">
        <td>
          <label nz-checkbox
                 [(ngModel)]="event.isChecked"
                 (ngModelChange)="subHeaderCheckUncheck(i, j, $event)">
          </label>
        </td>
        <td>{{ event.subject }}</td>
        <td>{{ event.triggerOn }}</td>
        <td>{{ event.remark }}</td>
      </tr>
    </tbody>
  </nz-table>
</div>
</ng-container>

  <ng-template #footerTpl>
    <!--*ngIf="canEditRole"-->
    <button *ngIf="canEditRetailProgram" nz-button nzType="primary" (click)="handleOkEmailsDrawer()" [nzLoading]="isLoadingOne"
      class="medium-btn small-btn mr-1">Update</button>
    <button nz-button nzType="default" (click)="cancelEmailsDrawer()" class="dlt-btn">Cancel</button>
  </ng-template>
</nz-drawer>
